<p
    [innerHTML]="
        'productDetail.campaign.startEndDate'
            | translateSafe
                : {
                      startDate: campaign?.startDate | date: 'dd.MM.yyyy',
                      endDate: campaign?.endDate | date: 'dd.MM.yyyy'
                  }
    "
></p>
